import { Component, NgZone, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DataService } from '../../../../../services/data.service';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectConfig } from '@ng-select/ng-select';
import { FileDownloadService } from '../../../../../services/file-download.service';
import { AutocompleteService } from '../../../../../services/autocomplete.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DocumentlistComponent } from '../../../../common/documentlist/documentlist.component';
import { NotificationService } from '../../../../../services/notification.service';
import { LocalStorageService } from '../../../../../services/local-storage.service';
import { WebSocketMessageService } from '../../../../../services/web-socket/web-socket-message.service';

@Component({
    selector: 'app-agent-sales-documents',
    templateUrl: '../../../../common/documentlist/documentlist.component.html',
    styleUrls: ['../../../../common/documentlist/documentlist.component.css']
})
export class AgentSalesDocumentsComponent extends DocumentlistComponent implements OnInit {
    constructor(
        protected toastr: ToastrService,
        protected api: DataService,
        protected modalService: NgbModal,
        protected modalConfig: NgbModalConfig,
        protected config: NgSelectConfig,
        protected zone: NgZone,
        protected notification: NotificationService,
        protected fileurl: FileDownloadService,
        protected ptautocomplete: AutocompleteService,
        protected ngxService: NgxUiLoaderService,
        protected localStorage: LocalStorageService,
        protected fileUrlService: FileDownloadService,
        protected webSocketMessageService: WebSocketMessageService
    ) {
        super(
            toastr,
            api,
            modalService,
            modalConfig,
            config,
            zone,
            notification,
            fileurl,
            ptautocomplete,
            ngxService,
            localStorage,
            fileUrlService,
            webSocketMessageService
        );
        this.canLinkOrUnlink = false;
    }

    ngOnInit() {
        super.ngOnInit();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/role-specific/agent/sales/documents/sales.documents.component.ts